module.exports = __webpack_public_path__ + "static/media/India.b1d31117.png";